import { useState, useEffect, useRef, useContext } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import authAxios from "../../components/authAxios";

import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import moment from 'moment';    

import { Radio, Steps, Button } from 'antd';


import NumberFormat from 'react-number-format';

import {UserContext} from "../../App"
import UserAlerts from "../../components/UserAlerts";
import DashboardHeader from "../../components/DashboardHeader";

import './Rentals.css'


function PropertyNew() {

    // const {response, error, fetchData}  = useAxios();
    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();
    const page_size = useContext(UserContext).page_size;

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');

    // const showModal = () => {
    //     setIsModalOpen(true);
    // };

    // const handleCancel = () => {
    //     setIsModalOpen(false);
    // };

    const { data: propertyTypes } = useQuery({
        queryKey: ['propertyTypes'],
        queryFn: async () => {
          const response = await authAxios.get("/rentals/property-types");
          return response.data
        },
    });

    const { data: owners } = useQuery({
        queryKey: ['owners'],
        queryFn: async () => {
          const response = await authAxios.get(`/rentals/owners/?page_size=${page_size}`);
          return response.data.results
        },
        keepPreviousData : true,
    });


    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [feeStructure, setFeeStructure] = useState('020');
    const [feePercentage, setFeePercentage] = useState('');
    const [feeAmount, setFeeAmount] = useState('');
    const [memo, setMemo] = useState('');
    const [nameError, setNameError] = useState(false)
    const [addressError, setAddressError] = useState(false);
    const [cityError, setCityError] = useState(false);


    // IMPORTANT: Initialise select, dates as null to avoid undefined errors
    const [owner, setOwner] = useState(null);
    const [startDate, setStartDate] = useState(null);


    const contactRef = useRef("");
    contactRef.showContactType=true   
    
    // const isStep0Valid = name.trim() !== '' && address.trim() !== '' && city.trim() !== '';
    // const isStep1Valid = () => {
    //     if (feeStructure === '020') {
    //         return (feePercentage.trim() !== '' && startDate);
    //     } else {
    //         return (feeAmount.trim() !== '' && startDate);
    //     }
    // };
    // const isStep2Valid = () => {
    //     return owner;
    // };

    const isStepValid = () => {
        if (currentStep === 0) {
          return name.trim() !== '' && address.trim() !== '' && city.trim() !== '';
        }
      
        if (currentStep === 1) {
          return feeStructure === '020'
            ? feePercentage.trim() !== '' && startDate
            : feeAmount.trim() !== '' && startDate;
        }
      
        if (currentStep === 2) {
          return !!owner;
        }
      
        return false;
    };

    const { Step } = Steps;
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => {
    setCurrentStep(currentStep + 1);
    };

    const prevStep = () => {
    setCurrentStep(currentStep - 1);
    };

    const mutation = useMutation({
        mutationFn: (property) => {
            return authAxios.post("/rentals/properties/", property);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['properties']);
            navigate('/dashboard/properties/')
        },
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        if (name === '') {
            setNameError(true)
        }

        if (address === '' ) {
            setAddressError(true)
        }

        if (city === '' ) {
            setCityError(true)
        }

        if (name && address && city ) {
            const fee_structure = feeStructure
            const fee_amount = feeAmount
            const start_date = startDate
            const fee_percentage =  feePercentage ? parseFloat(feePercentage)/100 : null;
            const landlord = owner?.id || null;

            const property = {client, name, address, city, country, user, memo, landlord, fee_structure, fee_percentage, fee_amount, start_date };

            console.log(property)
            mutation.mutate(property)
            
        } 
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])


    return(
        <div className="dashboard-main">
            <section className="dashboard-content">
                <section className="dashboard-form dashboard-form-compact">
                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>
                    <DashboardHeader dashboardTitle="Add Property" dashboardPreTitle="Rentals" />

                    <div className="property-new-steps">

                        <Steps size="small" current={currentStep}>
                            <Step title="Property" />
                            <Step title="Management Contract" />
                            <Step title="Owner" />
                            <Step disabled={true} title="Units" />

                        </Steps>

                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            {currentStep === 0 && (
                            <>
                                <TextField className="custom-input"
                                    value={name}
                                    onChange={(e) => {
                                        setNameError(false)
                                        setName(e.target.value)
                                    }}
                                    label="Name" 
                                    variant="outlined" 
                                    fullWidth
                                    required
                                    error={nameError}
                                />

                                <TextField className="custom-input"
                                    value={address}
                                    onChange={(e) => {
                                        setAddressError(false)
                                        setAddress(e.target.value)
                                    }}
                                    label="Physical Address" 
                                    variant="outlined" 
                                    fullWidth
                                    required
                                    error={addressError}
                                />  

                                <TextField className="custom-input"
                                    value={city}
                                    onChange={(e) => {
                                        setCityError(false)
                                        setCity(e.target.value)
                                    }}
                                    label="City/Town" 
                                    variant="outlined" 
                                    fullWidth
                                    required
                                    error={cityError}
                                />  
                            
                            </>
                            )}

                            {currentStep === 1 && (
                            <>
                                <Radio.Group 
                                    onChange={(e)=>setFeeStructure(e.target.value)} 
                                    className="custom-input"
                                    value={feeStructure}
                                >
                                    <Radio value="020">Percentage</Radio>
                                    <Radio value="010">Flat</Radio>
                                </Radio.Group>

                                {feeStructure === "020" &&
                                <NumberFormat 
                                    value={feePercentage}
                                    onChange={(e) => setFeePercentage(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Management Fee" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix="%"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    decimalSeparator="."
                                    allowNegative={false}
                                    isNumericString
                                />}
                                {feeStructure === "010" &&
                                <NumberFormat   
                                    value={feeAmount}
                                    onChange={(e) => setFeeAmount(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Management Fee" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    decimalScale={2}
                                    fixedDecimalScale
                                    decimalSeparator="."
                                    allowNegative={false}
                                    isNumericString
                                />}

                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        value={startDate}
                                        label="Start Date"
                                        inputFormat="DD-MM-YYYY" 
                                        onChange={(newDate) => {
                                            setStartDate(moment(newDate).format("YYYY-MM-DD"));
                                        }}
                                        error={!startDate}
                                        helperText={!startDate ? "Start date is required" : ""} 
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>
                            </>
                            )}
                            
                            {currentStep === 2 && (
                            <>
                                <Autocomplete
                                    value={owner}
                                    onChange={(event, newValue) => {
                                        setOwner(newValue);
                                        console.log("VALUE", newValue)
                                        }}
                                    options={owners}
                                    // getOptionLabel={(option) => option.name}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Owner"  /> }
                                />
                            </>
                            )}

                            <div className="button-border-top">
                                {currentStep > 0 && (
                                    <Button type="default" onClick={prevStep}>
                                        Previous
                                    </Button>
                                )}
                                {currentStep < 2 && (
                                    <Button type="primary" onClick={nextStep} disabled={!isStepValid()}>
                                        Next
                                    </Button>
                                )}
                                {currentStep === 2 && (
                                    <Button type="primary" htmlType="submit" disabled={!isStepValid()}>
                                        Save
                                    </Button>    
                                )}
                        
                            </div>
                        </form> 

                    </div>
                </section>
            </section> 

        </div>

    )   
}


export default PropertyNew;
